import { transformOfferEvent } from '@core/mappers/offer/transformOfferEvent';
import OfferEvent from '@core/models/offer/OfferEvent';

import { AbstractSseConnection } from './AbstractSseConnection';
import { MatchEvent } from '../types';
import { getOfferSseHost } from '@core/services/offer/helpers';

export class DailyOfferSseConnection extends AbstractSseConnection<OfferEvent[]> {
    constructor() {
        super('events/all', getOfferSseHost());
    }

    // eslint-disable-next-line class-methods-use-this
    processSseEvents(events: MatchEvent[]): OfferEvent[] {
        return events.map((event) => transformOfferEvent(event.data));
    }
}
